import React from 'react';
import { useUserContext } from '../context/user_context';
import styled from 'styled-components';
import { MdBusiness, MdLocationOn, MdVoicemail } from 'react-icons/md';
import { useHistory } from 'react-router-dom';
import { hasPermission } from '../rbacPermissionUtils';

const Card = () => {
  const history = useHistory();
  const { user, userRole } = useUserContext();

 

  // Default preview image
  const DEFAULT_IMAGE = 'https://i.imgur.com/ndu6pfe.png';

  console.log("He llo i am from card");
  console.log(user.results);
  // Extract user company data safely
  const userCompany = user.results?.userCompany || null;
  console.log("User Company Data:", userCompany);
  const isUserCompanyEmpty = !userCompany;

  // Construct user details
  const userd = {
    avatar_url: userCompany?.logo_s3_image || DEFAULT_IMAGE,
    name: userCompany?.name || '',
    company: userCompany?.phone || '',
    location: userCompany?.street_address || '',
    city: userCompany?.city || '',
    state: userCompany?.state || '',
    email: userCompany?.email || '',
    bio: 'Welcome Managing Director',
    since: userCompany?.company_since || '',
  };

  const { avatar_url, name, company, location, city, state, email, bio } = userd;

  const handleStartCompany = () => history.push('/company');

  return (
    <Wrapper>
      {isUserCompanyEmpty ? (
        <div className="welcome-guest">
          <p>Hello, Guest</p>
          {hasPermission(userRole, 'startCompany') && (
            <button className="start-group-button" onClick={handleStartCompany}>
              Start Company
            </button>
          )}
        </div>
      ) : (
        <div className="company-info">
          <header>
            <img src={avatar_url} alt={name} />
            <div>
              <h4>{name}</h4>
              <p>@{name || 'organiser'}</p>
            </div>
            {userRole === 'User' && <a onClick={handleStartCompany}>Edit Company</a>}
          </header>
          <p className="bio">{bio}</p>
          <div className="links">
            <p>
              <MdLocationOn /> {location}, {city}, {state}
            </p>
            <p>
              <MdVoicemail /> {email}
            </p>
            <p>
              <MdBusiness /> {company}
            </p>
          </div>
        </div>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.article`
  background: var(--clr-white);
  padding: 1.5rem 2rem;
  border-radius: var(--radius);
  position: relative;

  &::before {
    content: 'Welcome';
    position: absolute;
    top: 0;
    left: 0;
    transform: translateY(-100%);
    color: var(--clr-grey-5);
    text-transform: capitalize;
    padding: 0.5rem 1rem;
    font-size: 1rem;
  }

  header {
    display: flex;
    align-items: center;
    column-gap: 1rem;
    margin-bottom: 1rem;
    
    img {
      width: 75px;
      height: 75px;
      border-radius: 50%;
    }
    
    h4 {
      margin-bottom: 0.25rem;
    }
    
    p {
      margin-bottom: 0;
    }
    
    a {
      color: var(--clr-primary-5);
      border: 1px solid var(--clr-primary-5);
      padding: 0.25rem 0.75rem;
      border-radius: 1rem;
      text-transform: capitalize;
      cursor: pointer;
      
      &:hover {
        background: var(--clr-primary-5);
        color: var(--clr-white);
      }
    }
  }

  .bio {
    color: var(--clr-grey-3);
  }

  .links p {
    margin-bottom: 0.25rem;
    display: flex;
    align-items: center;
    
    svg {
      margin-right: 0.5rem;
      font-size: 1.3rem;
    }
  }

  .start-group-button {
    background-color: var(--clr-red-dark);
    color: #fff;
    border: none;
    border-radius: 10px;
    padding: 10px 50px;
    width: 200px;
    margin: 10px 60px;
    cursor: pointer;
  }
`;

export default Card;
